<div class="v4-filter-list flex-wrap">
  <!-- touched: {{ form.touched }} pristine: {{ form.pristine }} dirty: {{ form.dirty }} -->

  <ng-container [formGroup]="form">
    <div class="v4-filter-item">
      <v4-widget-input [placeholder]="'word.search' | translate" formControlName="keyword"></v4-widget-input>
    </div>

    <div class="v4-filter-item" *ngIf="datePickerType === 'simple'">
      <v4-range-picker [placeholder]="'word.date' | translate" formControlName="date_range"></v4-range-picker>
    </div>
    <ng-container *ngIf="datePickerType === 'detail'">
      <div class="v4-filter-item">
        <host-range-picker
          [placeholder]="'word.date' | translate"
          class="v4-filter-style"
          formControlName="date_range"></host-range-picker>
      </div>
      <div class="v4-filter-item">
        <host-range-time-picker class="v4-filter-style" formControlName="time_range"></host-range-time-picker>
      </div>
    </ng-container>
    <div class="v4-filter-item">
      <host-select
        class="v4-filter-style"
        formControlName="date_type"
        [listOfOption]="optionsOfDateType"
        placeholder="Date Type"></host-select>
    </div>

    <div class="v4-filter-item" *ngIf="filters.indexOf('house_ids') !== -1">
      <v4-house-select class="v4-filter-style" formControlName="house_ids"></v4-house-select>
    </div>

    @if (filters.indexOf("room_type_ids") !== -1) {
      <div class="v4-filter-item">
        <v4-room-types-select class="v4-filter-style" formControlName="room_type_ids"></v4-room-types-select>
      </div>
    }

    <div class="v4-filter-item" *ngIf="filters.indexOf('channels') !== -1">
      <host-simple-multi-select
        class="v4-filter-style"
        formControlName="channels"
        placeholderKey="word.select_option.placeholder.channel"
        [listOfOption]="optionsOfChannel"></host-simple-multi-select>
    </div>

    <div class="v4-filter-item" *ngIf="showAccountPicker && filters.indexOf('thirdparty_account_ids') !== -1">
      <host-select
        class="v4-filter-style"
        formControlName="thirdparty_account_ids"
        [placeholder]="'word.select_option.placeholder.account' | translate"
        [listOfOption]="optionsOfAccount"></host-select>
    </div>

    <div class="v4-filter-item" *ngIf="filters.indexOf('operator_ids') !== -1">
      <host-simple-multi-select
        class="v4-filter-style"
        formControlName="operator_ids"
        placeholderKey="reservation.list.filters.filter_sub_account.placeholder"
        [listOfOption]="optionsOfOperator"></host-simple-multi-select>
    </div>

    <div class="v4-filter-item" *ngIf="filters.indexOf('settlement_status') !== -1">
      <host-select
        class="v4-filter-style"
        [placeholder]="'word.select_option.placeholder.settlement_status' | translate"
        formControlName="settlement_status"
        [defaultValue]="null"
        [listOfOption]="optionsOfSettlementStatus"></host-select>
    </div>

    <div class="v4-filter-item" *ngIf="filters.indexOf('house_fee_range') !== -1">
      <host-range-fee-picker class="v4-filter-style" formControlName="house_fee_range"></host-range-fee-picker>
    </div>

    <div class="v4-filter-item" *ngIf="filters.indexOf('tags') !== -1">
      <host-condition-switch-picker
        class="v4-filter-style"
        formControlName="tags"
        [placeholder]="'reservation.list.filters.filter_tag.placeholder' | translate"
        [listOfOption]="optionsOfTag"></host-condition-switch-picker>
    </div>

    <div class="v4-filter-item" *ngIf="filters.indexOf('labels') !== -1">
      <host-condition-switch-picker
        class="v4-filter-style"
        formControlName="labels"
        [placeholder]="'reservation.list.filters.filter_label.placeholder' | translate"
        [listOfOption]="optionsOfLabel"></host-condition-switch-picker>
    </div>

    <div class="v4-filter-item" *ngIf="filters.indexOf('hour_reservation') !== -1">
      <host-select
        class="v4-filter-style"
        formControlName="hour_reservation"
        [placeholder]="'word.select_option.placeholder.hour_reservation' | translate"
        [defaultValue]="null"
        [listOfOption]="optionsOfHourReser"></host-select>
    </div>

    <div class="v4-filter-item" *ngIf="filters.indexOf('extension_reservation') !== -1">
      <host-select
        class="v4-filter-style"
        formControlName="extension_reservation"
        [placeholder]="'reservation.list.filters.filter_ext_res.placeholder' | translate"
        [defaultValue]="null"
        [listOfOption]="optionsOfExtReser"></host-select>
    </div>

    <div class="v4-filter-item" *ngIf="filters.indexOf('reservation_box') !== -1">
      <host-select
        class="v4-filter-style"
        formControlName="reservation_box"
        [placeholder]="'word.select_option.placeholder.res_box' | translate"
        [defaultValue]="null"
        [listOfOption]="optionsOfReserBox"></host-select>
    </div>

    <div class="v4-filter-item" *ngIf="filters.indexOf('creator_operator_id') !== -1">
      <host-select
        class="v4-filter-style"
        formControlName="creator_operator_id"
        [placeholder]="'reservation.list.filters.filter_creator.placeholder' | translate"
        [listOfOption]="optionsOfCreator"></host-select>
    </div>
  </ng-container>

  <div class="v4-filter-item">
    <host-filters-picker
      [listOfOption]="optionsOfFilter"
      [(ngModel)]="filters"
      (ngModelChange)="onFilterChange($event)"></host-filters-picker>
  </div>

  <div class="v4-filter-item" *ngIf="form.dirty">
    <a nz-button nzType="link" (click)="form.reset()">
      {{ "word.reset" | translate }}
      <!-- Reset -->
    </a>
  </div>
</div>
